module.exports = __webpack_public_path__ + "img/report-d.2d40083.svg";